import { createSlice } from "@reduxjs/toolkit";

import {
	SORTING_RULES,
	FORM_INPUT_SLICE_NAME,
	SORTING_VALUES_ARR,
} from "../utility/constants";
import { params } from "../../../components/utility";
import QueryParams from "../utility/queryParams";

// initial state for forms data
export const initialFormData = {
	keywordSearch: "",
	locationFacet: "",
	industryFacet: "",
	companyTypesFacet: "",
	pagination: 1,
	sortingRule: SORTING_RULES.NEWEST,
	isResetClicked: false,
};

export const resetFormData = {
	keywordSearch: "",
	locationFacet: "",
	industryFacet: "",
	companyTypesFacet: "",
	pagination: 1,
	sortingRule: SORTING_RULES.NEWEST,
	isResetClicked: false,
};

const { page_number, cities, industry, keyword, sort, type } = params;

const updateFormData = (key, value) => {
	if (value && value.length > 0) initialFormData[key] = value;
};

try {
	updateFormData("pagination", page_number > 1 ? page_number : null);
	updateFormData("keywordSearch", keyword);
	updateFormData(
		"sortingRule",
		SORTING_VALUES_ARR.includes(sort) ? sort : null,
	);
	updateFormData("companyTypesFacet", type);
	updateFormData("locationFacet", cities);
	updateFormData("industryFacet", industry);
} catch (e) {
	console.error(e);
}

// slice for selected form data
export const formDataSlice = createSlice({
	name: FORM_INPUT_SLICE_NAME,
	initialState: {
		value: initialFormData,
	},
	reducers: {
		changeFormInputData: (state, action) => {
			state.value = { ...action.payload };
			QueryParams(state.value);
		},
	},
});

export const { changeFormInputData } = formDataSlice.actions;

export default formDataSlice.reducer;
